<template>
  <div class>
    <STable ref="tableref" :url="url" :columns="columns" :selection="false" :query="query" :handles="handles" :toolbar="toolbar" />
    <el-dialog v-dialogDrag title="作废" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="closeDialog" width="50%" center>
      <div style="width: 90%;margin:0 auto">
        <el-form ref="voidFormRef" :model="voidForm" :rules="voidRules" label-width="80px">
          <el-form-item label="作废原因" prop="cancelledDetail">
            <el-input v-model="voidForm.cancelledDetail" type="textarea" :rows="4" placeholder="请输入作废原因" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="voidSubmit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'UserEquity',
  data() {
    return {
      dialogVisible: false, // 用户列表弹窗
      id: '',
      url: '/admin/privilege/list',
      columns: [
        {
          label: '权益名称',
          prop: 'name'
        },
        {
          label: '抵扣类型',
          prop: 'type',
          template: function(index, record) {
            return record.type == '2' ? '电费' : record.type == '1' ? '服务费' : '总费用'
          }
        },
        {
          label: '权益折扣',
          prop: 'discount',
          template: function(index, record) {
            return record.discount + '%'
          }
        },
        {
          label: '使用说明',
          prop: 'info'
        },
        {
          label: '修改人',
          prop: 'updateUser'
        },
        {
          label: '修改时间',
          prop: 'updateTime'
        },
        {
          label: '作废原因',
          prop: 'reason'
        }
      ],
      query: [
        {
          label: '权益名称',
          prop: 'name',
          placeholder: '请输入权益名称'
        },
        {
          label: '抵扣类型',
          prop: 'type',
          placeholder: '请选择抵扣类型',
          type: 'select',
          data: [
            {
              label: '电费',
              value: '2'
            },
            {
              label: '服务费',
              value: '1'
            },
            {
              label: '总费用',
              value: '3'
            }
          ]
        },
        {
          label: '状态',
          prop: 'status',
          placeholder: '请选择权益状态',
          type: 'select',
          data: [
            {
              label: '正常',
              value: 'true'
            },
            {
              label: '作废',
              value: 'false'
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'equityManagement.userEquity.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'addUserEquity', query: { type: 'add' }
            })
          }
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            permission: 'equityManagement.userEquity.update',
            type: 'primary',
            getLabelDisabled: record => {
              return record.status == false
            },
            handle: (resp) => {
              this.$router.push({
                path: './reviseUserEquity', query: { id: resp.id, type: 'revise' }
              })
            }
          },
          {
            label: '作废',
            permission: 'equityManagement.userEquity.invalidation',
            type: 'primary',
            getLabelDisabled: record => {
              return record.status == false
            },
            before: (index, record) => {
              this.dialogVisible = true
              this.id = record.id
            }
          },
          {
            label: '复制',
            permission: 'equityManagement.userEquity.duplication',
            type: 'primary',
            handle: (resp) => {
              this.$router.push({
                path: './addUserEquity', query: { id: resp.id, type: 'add' }
              })
            }
          }
        ]
      },
      voidForm: {
        cancelledDetail: ''// 作废原因
      },
      voidRules: {
        cancelledDetail: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount() {},
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.id = ''
    },
    // 作废弹窗的提交
    voidSubmit() {
      const data = {
        id: this.id,
        reason: this.voidForm.cancelledDetail,
        status: false
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/privilege/cancel',
        method: 'post',
        data: data,
        callback: resp => {
          this.dialogVisible = false
          this.id = ''
          this.$refs.tableref.queryTable()
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.flexJCenter {
  display: flex;
  justify-content: center;
}

.mt-25 {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/equityManagement/userEquity.vue